import SimpleModal from "cpl-react-common/components/Modals/SimpleModal";
import { useDispatch, useSelector } from "react-redux";
import {
  migrateAllCoreAccounts,
  selectFailedUserEmails,
  selectIsLoading,
  selectShowMigrationResults,
  setShowMigrationResults,
} from "./UsersMigrationSlice";
import { Permission } from "services/userSession/UserPermittedComponent";
import { Permissions } from "cpl-react-common/components/Enums/Permissions";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersMedical } from "@fortawesome/pro-solid-svg-icons";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";

const ImportCoreUsersButton: React.FC = () => {
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();
  const failedEmails = useSelector(selectFailedUserEmails);
  const showResultsModal = useSelector(selectShowMigrationResults);
  const isLoading = useSelector(selectIsLoading);

  function migrateAllUsersClick() {
    thunkDispatch(migrateAllCoreAccounts());
  }
  return (
    <Permission permissionPredicate={(permission) => permission === Permissions.AddUsers}>
      <SimpleModal
        showModal={showResultsModal}
        modalTitle="Migration Results"
        dismissModalCallback={() => {
          dispatch(setShowMigrationResults(false));
        }}
      >
        <p>
          Connect invitations have been sent to all outstanding Core users. They should receive an email to their Core
          user email address shortly containing instructions on how to finish setting up their Connect account
        </p>
        {failedEmails.length > 0 ? (
          <>
            <p>
              However, the following user(s) were unable to be invited. This may be due to not having an email address
              or telephone number on their Core user profile.
            </p>
            <ul>
              {failedEmails.map((i) => (
                <li key={i}>{i}</li>
              ))}
            </ul>
          </>
        ) : (
          ""
        )}
      </SimpleModal>
      <button
        data-test-id="user-table__import-button"
        className={"btn btn-primary"}
        onClick={() => migrateAllUsersClick()}
        disabled={isLoading}
      >
        <ActivityIndicator isBusy={isLoading}>
          <FontAwesomeIcon icon={faUsersMedical} /> Import Core Users
        </ActivityIndicator>
      </button>
    </Permission>
  );
};

export default ImportCoreUsersButton;
